<div class="layout">
  <header class="header">
    <a routerLink="/screen/DASHBOARD" class="brand">
      <img alt="logo" class="main-logo" src="/assets/white_theme_without_background.png" />
    </a>
    <div class="user-info" *ngIf="userName() as u">
      <span class="user-name">{{ u }}</span>
      <button class="logout-button" (click)="onLogout()">Logout</button>
    </div>
  </header>

  <div class="toolbar">
    <nav>
      <a
        routerLink="/screen/DASHBOARD"
        routerLinkActive="nav-active"
        [routerLinkActiveOptions]="{ exact: true }"
        [class.nav-active]="activeKey() === 'DASHBOARD'"
      >{{ dashboardLabel() }}</a>
      @for (item of screenItems(); track trackByKey($index, item)) {
        <a
          [routerLink]="['/screen', item.key]"
          routerLinkActive="nav-active"
          [class.nav-active]="activeKey() === item.key"
          >{{ item.label }}</a
        >
      }
    </nav>
  </div>

  <main class="page">
    <router-outlet />
  </main>
</div>



